<div class="logout">
  <groupui-button size="s" inverted="true" size="s" variant="tertiary" (click)="logoutUser()">
    <div class="logout-button">
      <img src="assets/icons/shell/leave-24.svg" alt="" />
    </div>
  </groupui-button>
</div>
